/**
 * Hipland Store Chat — Client
 * Connects to OpenClaw (Pink Bot) via chat.hipland.co bridge
 */
(function() {
  'use strict';

  const BRIDGE_URL = 'https://chat.hipland.co';

  const Chat = {
    sessionId: null,
    elements: {},

    init() {
      const container = document.querySelector('.shop-ai-chat-container');
      if (!container) return;

      this.elements = {
        container,
        bubble: container.querySelector('.shop-ai-chat-bubble'),
        window: container.querySelector('.shop-ai-chat-window'),
        close: container.querySelector('.shop-ai-chat-close'),
        input: container.querySelector('.shop-ai-chat-input input'),
        sendBtn: container.querySelector('.shop-ai-chat-send'),
        messages: container.querySelector('.shop-ai-chat-messages')
      };

      this.sessionId = sessionStorage.getItem('hipland_chat_session') || this.genId();
      sessionStorage.setItem('hipland_chat_session', this.sessionId);

      this.bindEvents();
      this.showWelcome();
    },

    genId() {
      return 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },

    bindEvents() {
      const { bubble, close, input, sendBtn, window } = this.elements;

      bubble.addEventListener('click', () => {
        window.classList.toggle('active');
        if (window.classList.contains('active')) {
          setTimeout(() => input.focus(), 300);
          this.scrollDown();
        }
      });

      close.addEventListener('click', () => {
        window.classList.remove('active');
      });

      const send = () => {
        const msg = input.value.trim();
        if (!msg) return;
        this.send(msg);
        input.value = '';
      };

      input.addEventListener('keypress', e => {
        if (e.key === 'Enter') send();
      });
      sendBtn.addEventListener('click', send);
    },

    showWelcome() {
      const msg = window.shopChatConfig?.welcomeMessage || "Hey, I'm Arlo. How can I help?";
      this.addMessage(msg, 'assistant');
    },

    addMessage(text, role) {
      const el = document.createElement('div');
      el.classList.add('shop-ai-message', role);
      el.textContent = text;
      this.elements.messages.appendChild(el);
      this.scrollDown();
      return el;
    },

    scrollDown() {
      setTimeout(() => {
        this.elements.messages.scrollTop = this.elements.messages.scrollHeight;
      }, 100);
    },

    showTyping() {
      const el = document.createElement('div');
      el.classList.add('shop-ai-typing-indicator');
      el.innerHTML = '<span></span><span></span><span></span>';
      this.elements.messages.appendChild(el);
      this.scrollDown();
      return el;
    },

    async send(message) {
      this.addMessage(message, 'user');
      const typing = this.showTyping();

      try {
        const res = await fetch(`${BRIDGE_URL}/chat`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: message,
            session_id: this.sessionId,
            country: 'AU'
          })
        });

        const data = await res.json();
        typing.remove();

        if (data.response) {
          this.addMessage(data.response, 'assistant');
        } else {
          this.addMessage("Sorry, something went wrong. Please email hello@hipland.co for help.", 'assistant');
        }
      } catch (err) {
        typing.remove();
        this.addMessage("Sorry, I'm having trouble connecting. Please email hello@hipland.co for help.", 'assistant');
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => Chat.init());
})();
